const STATUS_DICT = {
  pending: 'Ожидает',
  processing: 'В обработке',
  submitted: 'Отправлен',
  awaiting_payment: 'Ожидает оплаты',
  reserved: 'В резерве',
  paid: 'Оплачен',
  shipped: 'Отгружен',
  received: 'Получен',
  completed: 'Закрыт',
  cancelled: 'Отменён',
  draft: 'Черновик',
  confirmed: 'Подтверждён',
};

export function translateStatus(status) {
  return STATUS_DICT[status] ?? status ?? '';
}

/**
 * Цветовая категория для бейджа статуса.
 */
export function statusKind(status) {
  switch (status) {
    case 'submitted':
    case 'pending':
    case 'draft':
    case 'processing':
      return 'info';
    case 'awaiting_payment':
      return 'warning';
    case 'reserved':
    case 'paid':
    case 'confirmed':
      return 'progress';
    case 'shipped':
      return 'shipped';
    case 'received':
    case 'completed':
      return 'success';
    case 'cancelled':
      return 'danger';
    default:
      return 'info';
  }
}
